import { addToCart } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])

  if ($forms.length) {
    for (const $form of $forms) {
      $form.addEventListener('submit', (event) => {
        event.preventDefault()
        const $submitButton = $form.querySelector('[type="submit"]')

        $submitButton.classList.add('loading')
        $submitButton.setAttribute('disabled', true)

        const formData = new FormData($form)
        const id = formData.get('id')
        const quantity = 1

        // Get line item properties
        const properties = {}
        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.+)\]$/)
          if (propertyMatch && value) {
            properties[propertyMatch[1]] = value
          }
        }

        addToCart({ id, quantity, properties }).then(() => {
          $submitButton.removeAttribute('disabled')
          $submitButton.classList.remove('loading')
        })
      })
    }

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html
      for (const $form of $forms) {
        if (!content) return
        $form.innerHTML = content.innerHTML
      }
    })

    document.addEventListener('nova:product:render-upsell', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-product-upsell')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-size-guide', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-size-guide-content')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }

      for (const content of document.querySelectorAll('size-guide-drawer')) {
        if (content) {
          content.reInit()
        }
      }
    })

    document.addEventListener('nova:product:render-inventory-callout', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-inventory-callout')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-collapsible-tabs', (event) => {
      const content = event.detail.html
      if (!content || content.length === 0) return

      for (const [index, newTab] of content.entries()) {
        if (!newTab) continue

        const existingTabs = document.querySelectorAll('.js-update-on-variant-change')
        if (existingTabs[index]) {
          existingTabs[index].innerHTML = newTab.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-product-callout', (event) => {
      const content = event.detail.html
      if (!content) return

      const currentCallout = document.querySelector('.js-product-callout');
      if (currentCallout) {
        currentCallout.innerHTML = content.innerHTML
      }
    })
  }

  if (typeof $sizeGuideDrawer !== 'undefined') {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }

  const container = document.querySelector('.product__info-container');

  // Close all other details when one is shown
  container.addEventListener('sl-show', event => {
    if (event.target.localName === 'sl-details') {
      for (const details of container.querySelectorAll('sl-details')) {
        details.open = event.target === details;
      }
    }
  });
}, { once: true })
